import api from '@pray/shared/utils/api';

import type { AdminBrandKitQueueItem, BrandKitResponse } from './types';

export async function getAdminBrandKits(): Promise<AdminBrandKitQueueItem[]> {
  const response = await api.executeGetRequest('/web/studio/admin/brand-kits');

  return response.data.data;
}

export async function setAdminBrandKit({
  artistId,
  status,
  opusBrandTemplateId,
}: {
  artistId: string;
  status?: 'building';
  opusBrandTemplateId?: string | null;
}): Promise<BrandKitResponse> {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/admin/artists/${artistId}/brand-kit`;
  const response = await api.executePutRequest(url, {
    ...(status ? { status } : {}),
    ...(opusBrandTemplateId !== undefined ? { opus_brand_template_id: opusBrandTemplateId?.trim() || null } : {}),
  });

  return response.data.data;
}
